/* eslint-disable i18next/no-literal-string -- query cache keys, not copy */
export const FORMAT_SPECS_ADMIN_KEYS = {
  all: ['format-specs-admin'] as const,
  library: () => [...FORMAT_SPECS_ADMIN_KEYS.all, 'library'] as const,
  history: (formatKey: string) => [...FORMAT_SPECS_ADMIN_KEYS.all, 'history', formatKey] as const,
};
